import EditorPage from './EditorPage.container'

export default EditorPage
